module.exports = __webpack_public_path__ + "static/media/design_sprint_4.ee2ea084.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/design_sprint_4.png
// module id = 431
// module chunks = 0